<template>
  <div>
    <h1 class="title has-text-centered is-spaced">
      <go-to-dashboard-button />
      {{ $t("refillsStock.title") }}
      <button class="button action-button" @click="$emit('search')">
        <b-icon icon="sync-alt" />
      </button>
      <button class="button action-button" @click="$emit('download')">
        <b-icon icon="save" />
      </button>
    </h1>

    <div class="columns">
      <div class="column is-4">
        <b-field :label="$t('common.store')" label-position="on-border">
          <b-select
            v-model="storeId"
            expanded
            @input="$emit('update-store', storeId)"
          >
            <option value="" disabled>{{ $t("common.store") }}</option>
            <option v-for="store in stores" :key="store._id" :value="store._id">
              {{ store.storeInfo.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('refillsStock.barcode')" label-position="on-border">
          <b-input
            v-model.trim="barcode"
            @input="$emit('update-barcode', barcode)"
          />
        </b-field>
      </div>
      <div class="column is-4">
        <b-field
          :label="$t('refillsStock.operations')"
          label-position="on-border"
        >
          <b-input
            v-model.number="refillsOperations"
            type="number"
            min="1"
            max="10"
            @input="$emit('update-refills', refillsOperations)"
          />
        </b-field>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  components: { goToDashboardButton },
  data() {
    return { storeId: "", barcode: "", refillsOperations: 2 };
  },
  computed: mapGetters(["stores"])
};
</script>

<style scoped>
.action-button {
  margin-left: 0.5rem;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
